<template>
  <div>
      <div style="margin: 1%" v-if="userInfo">
            <b-form-group label-align="right" label-cols="4" label-cols-xl="2" label-cols-md="4" label="ID" disabled>
              <b-form-input id="input-number" type="number" v-model="userInfo.user_id"/>
            </b-form-group>

            <b-form-group label-align="right" label-cols="4" label-cols-xl="2" label-cols-md="4" :label="$t('Basic account')"  disabled>
              <b-form-input type="number" v-model="userInfo.basic_account"/>
            </b-form-group>

            <b-form-group disabled label-align="right" label-cols="4" label-cols-xl="2" label-cols-md="4" :label="$t('Bonus')" >
              <b-form-input type="number" v-model="totalBonus"/>
            </b-form-group>

            <b-form-group label-align="right" label-cols="4" label-cols-xl="2" label-cols-md="4" :label="$t('Login')" @validation="validation">
              <b-form-input type="text" :state="inputLoginState"  aria-describedby="input-live-help input-live-feedback" trim v-model="userInfo.login"/>
              <b-form-invalid-feedback id="input-live-feedback">
                {{ $t('Enter only english letters, numbers, at least 1 letter') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label-align="right" label-cols="4" label-cols-xl="2" label-cols-md="4" :label="$t('Name')">
              <b-form-input type="text" v-model="userInfo.full_name"/>
            </b-form-group>

            <b-form-group label-align="right" label-cols="4" label-cols-xl="2" label-cols-md="4" >
              <md-button class="md-raised" @click="() => { this.passwordFieldsType = this.passwordFieldsType == 'password' ? 'text' : 'password' }" >{{$t('Show/Hide password')}}</md-button>
            </b-form-group>

            <b-form-group label-align="right" label-cols="4" label-cols-xl="2" label-cols-md="4" :label="$t('Password')" @validationPass="validationPass">
              <b-form-input :type="this.passwordFieldsType" v-model="userInfo.password" :state="inputPasswordState" aria-describedby="inputPassfeedback"/>
              <b-form-invalid-feedback id="inputPassfeedback">
                {{ $t('Password doesn`t match') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label-align="right" label-cols="4" label-cols-xl="2" label-cols-md="4" :label="$t('Confirm password')" >
              <b-form-input :type="this.passwordFieldsType" v-model="currentRow.password"/>
            </b-form-group>

            <b-form-group label-align="right" label-cols="4" label-cols-xl="2" label-cols-md="4" :label="$t('Payment in advance')" >
              <b-form-checkbox v-model="userInfo.advance_payment"/>
            </b-form-group>
      </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      passwordFieldsType: 'password'
    }
  },
  props: {
    currentRow: null,
    userInfo: null
  },
  methods: {
    validation () {
      if (this.userInfo.login.length === 0) {
        return false
      }
      let strArray = this.userInfo.login.split('')
      let goodChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@.,-+_/()'.split('')
      strArray = strArray.filter((value) => {
        return goodChars.includes(value)
      })
      return strArray.join('').length === this.userInfo.login.length
    },
    validationPass () {
      if (this.userInfo.password !== this.currentRow.password || this.currentRow.password !== this.userInfo.password || this.userInfo.password.length === 0) {
        return false
      } else {
        return true
      }
    }
  },
  computed: {
    inputLoginState () {
      return this.validation()
    },
    inputPasswordState () {
      return this.validationPass()
    },
    totalBonus () {
      return Math.floor(this.$store.getters['Users/TOTAL_BONUS'])
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_TOTAL_BONUS', this.userInfo.user_id)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/main/main.vue